import { c as _c } from "react/compiler-runtime";
import LINKS from '../../../../../configs/links';
import Button from '../../../../common/base/Button';
import CodeSnippet from '../../../../common/CodeSnippet';
import Link from '../../../../common/base/Link';
import Skeleton from '../../../../common/base/Skeleton';
import Tabs from '../../../../common/base/Tabs';
import Text from '../../../../common/base/Text';
import CopyableField from '../../../../common/CopyableField';
import { Div } from '../../../../common/helpers/StyledUtils';
import { BASE_URL, example_tabs, OutpostGetStartedStepProps } from '../GetStartedView';
import { getOutpostInitExample, getOutpostInstallCommand, getOutpostSnippetLanguage, OutpostExampleLanguage, useOutpostSnippetMaskableValue } from '../../utils/outpostSnippets';
const DownloadSDK: React.FC<OutpostGetStartedStepProps> = t0 => {
  const $ = _c(25);
  const {
    context: t1,
    mutateContext,
    nextStep,
    is_current_step
  } = t0;
  const {
    active_language
  } = t1;
  let t2;
  if ($[0] !== active_language) {
    t2 = getOutpostInstallCommand(active_language);
    $[0] = active_language;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const install_command = t2;
  let t3;
  if ($[2] !== active_language) {
    t3 = getOutpostInitExample(active_language);
    $[2] = active_language;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const init_example = t3;
  const maskable_value = useOutpostSnippetMaskableValue();
  let t4;
  if ($[4] !== active_language) {
    t4 = getOutpostSnippetLanguage(active_language);
    $[4] = active_language;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const init_example_language = t4;
  let t5;
  if ($[6] !== mutateContext) {
    t5 = lang => mutateContext({
      active_language: lang as OutpostExampleLanguage
    });
    $[6] = mutateContext;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      b: 4
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== active_language || $[10] !== t5) {
    t7 = <Tabs compact={true} tabs={example_tabs} active_tab={active_language} onTabSelected={t5} m={t6} />;
    $[9] = active_language;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== active_language || $[13] !== init_example || $[14] !== init_example_language || $[15] !== install_command || $[16] !== maskable_value) {
    t8 = active_language === "http" ? <Div><Text semi={true} size="xs" muted={true} m={{
        b: 1
      }}>API Base URL</Text><CopyableField mono={true} value={BASE_URL} m={{
        b: 4
      }} /><Text semi={true} size="xs" muted={true} m={{
        b: 1
      }}>API Secret</Text>{maskable_value ? <CopyableField mono={true} value={maskable_value.full_value} secret={true} m={{
        b: 4
      }} /> : <Skeleton large={true} />}<Link href={LINKS.outpost.api_ref} target="_blank">View API reference →</Link></Div> : <>{install_command && <Div m={{
        b: 4
      }}><Text semi={true} size="xs" muted={true} m={{
          b: 1
        }}>Install SDK</Text><CopyableField mono={true} value={install_command} /></Div>}{init_example && <><Text semi={true} size="xs" muted={true} m={{
          b: 1
        }}>Initialize SDK</Text><CodeSnippet code={init_example} language={init_example_language} maskable_value={maskable_value} /></>}</>;
    $[12] = active_language;
    $[13] = init_example;
    $[14] = init_example_language;
    $[15] = install_command;
    $[16] = maskable_value;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== is_current_step || $[19] !== nextStep) {
    t9 = is_current_step && <Button outline={true} onClick={nextStep} m={{
      t: 6
    }}>Next</Button>;
    $[18] = is_current_step;
    $[19] = nextStep;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <Div>{t7}{t8}{t9}</Div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
export default DownloadSDK;